import React from 'react';
import Loja from '~/components/Loja';
import { BuscaParceiro, BuscaProduto } from '~/components/NovosInputs';
import { useRomaneio } from '../../hooks/useRomaneio';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { Table, ColunmHead, Colunm } from './styles';
import { HistoricoProduto } from '~/components/HistoricoProduto';
import { formatCurrencyAsText } from '~/utils/functions';

export const FilterFields: React.FC = () => {
  const {
    formTela,
    handleProductSelected,
    productSelected,
    onCancelProduct,
    handleLojaSelected,
    lojaSelected,
    handleFocus,
    disabledInputs,
    setDisabledInputs,
    isUpdate,
  } = useRomaneio();
  const {
    register,
    control,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
  } = formTela;

  const formatFlag = (flag?: boolean | null) =>
    flag == null ? '' : flag ? 'SIM' : 'NÃO';

  const getFormattedEstoque = (produto: any) => {
    if (!produto) return '';

    const estoque = produto.qtd_total_estoque ?? produto.qtd_est_atual ?? null;

    if (estoque == null) return '';

    if (produto.flg_ipv) {
      return formatCurrencyAsText(estoque, 3);
    }

    return Number(estoque);
  };

  return (
    <>
      <div className="d-flex flex-column gap-2">
        <Loja
          selectedLoja={lojaSelected}
          onChange={(selected: number) => {
            handleLojaSelected(selected);
            handleFocus('busca_parceiro');
          }}
          isDisabled={disabledInputs.loja}
        />
        {!isUpdate && (
          <>
            <BuscaParceiro
              label="Fornecedor *"
              placeholder={
                !lojaSelected
                  ? 'Selecione uma Loja'
                  : 'Informe pelo menos 3 caracteres do Fornecedor'
              }
              name="busca_parceiro"
              register={register}
              disabled={!lojaSelected || disabledInputs.parceiro}
              customOptions={{
                buscarPor: {
                  fornecedor: true,
                },
              }}
              control={control}
              isError={!!errors.busca_parceiro}
              changeSelected={(selected) => {
                clearErrors('busca_parceiro');
                setValue('busca_parceiro', {
                  value: selected.value,
                  label: selected.label,
                });
                setDisabledInputs((prev) => ({
                  ...prev,
                  produto: false,
                }));
                handleFocus('product');
              }}
            />
            <div className="d-flex align-items-end gap-3">
              <div className="produto">
                <BuscaProduto
                  id="product"
                  label="Busca Produto *"
                  placeholder={
                    !watch('busca_parceiro')?.value
                      ? 'Selecione um Fornecedor'
                      : 'Digite 3 caracteres para buscar por um produto'
                  }
                  name="busca_produto"
                  register={register}
                  buscaNasLojas={lojaSelected}
                  control={control}
                  disabled={disabledInputs.produto}
                  isError={!!errors.busca_produto}
                  customOptions={{
                    buscaPadrao: 'Produto',
                    buscarPor: ['Produto'],
                    hideBuscarPor: true,
                  }}
                  getProduct={(selected: any) => {
                    clearErrors('busca_produto');
                    handleProductSelected(selected[0]);
                  }}
                  setValue={setValue}
                />
              </div>
              <CustomButtonNovo
                label="Cancelar"
                type="button"
                variant="error"
                height="38px"
                disabled={!productSelected.cod_produto}
                onClick={onCancelProduct}
                style={{ marginTop: '1.69rem' }}
              />
            </div>
          </>
        )}
        <Table>
          <thead style={{ fontWeight: 'normal' }}>
            <tr>
              <ColunmHead align="right">Código</ColunmHead>
              <ColunmHead align="right">Descrição</ColunmHead>
              <ColunmHead align="right">Estoque Atual</ColunmHead>
              <ColunmHead align="right">UN Compra</ColunmHead>
              <ColunmHead align="right">Peso Variável?</ColunmHead>
              {productSelected.cod_produto && (
                <ColunmHead align="right">Histórico</ColunmHead>
              )}
            </tr>
          </thead>
          <tbody>
            <tr style={{ height: '39px' }}>
              <Colunm align="center">{productSelected.cod_produto}</Colunm>
              <Colunm align="center" width="auto">
                {productSelected.des_produto}
              </Colunm>
              <Colunm align="center">
                {getFormattedEstoque(productSelected)}
              </Colunm>
              <Colunm align="center">
                {productSelected.des_unidade_compra}
              </Colunm>
              <Colunm align="center">
                {formatFlag(productSelected.flg_ipv)}
              </Colunm>
              {productSelected.cod_produto && productSelected.cod_loja && (
                <Colunm align="center" style={{ justifyItems: 'center' }}>
                  <HistoricoProduto
                    codLoja={productSelected.cod_loja}
                    codProduto={productSelected.cod_produto}
                    hasIcone
                  />
                </Colunm>
              )}
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};
